<template>
  <div>
    <top-menu :user="user" :active="topMenuActive" @defaultActive="defaultActive" :agent="agent" :userLevel="userLevel" :userCenterCount="userCenterCount"></top-menu>
    <div class="feedcommit">
      <p class="title">
        默认评价为本订单所有的数据进行评价,如果需要单个数据进行评价,<span>请备注您要评价的数据,</span>点评后还可以获得一定的积分。
      </p>
      <el-form ref="form" label-width="80px">
        <el-form-item label="订单编号:">
          <span style="color:red;">{{code}}</span>
        </el-form-item>
      </el-form>
      <div class="edit">
        <quill-editor
          v-model="content"
          ref="myQuillEditor"
          :options="editorOption"
          @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
          @change="onEditorChange($event)">
        </quill-editor>
      </div>
      <div class="btn">
        <el-button type="danger"  @click="msgpost" v-show="!btntype.disabled">提交</el-button>
        <el-button type="info" disabled="" v-show="btntype.disabled">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { quillEditor } from 'vue-quill-editor' // 调用编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import eventBus from '../../common/eventBus.js'
import TopMenu from './feedback'
export default {
  name: 'message',
  components: {
    quillEditor,
    TopMenu
  },
  data () {
    return {
      radio: '1',
      user: {
        userId: '',
        userName: '',
        nickName: '',
        sex: '',
        rank: ''
      },
      agent: '',
      userLevel: '',
      topMenuActive: true,
      menu: [
        {
          name: 'account',
          check: ''
        },
        {
          name: 'orders',
          check: ''
        },
        {
          name: 'message',
          check: ''
        },
        {
          name: 'voucher',
          check: ''
        },
        {
          name: 'delivery',
          check: ''
        },
        {
          name: 'cloudDisk',
          check: ''
        }, {
          name: 'bill',
          check: ''
        }
      ],
      userCenterCount: {
        orderWaitPayCount: 0,
        orderProducingCount: 0,
        orderProducedCount: 0,
        allVoucherCount: 0,
        voucherCount: 0,
        producedFileCount: 0,
        cartCount: 0
      },
      code: '',
      btntype: {
        type: 'danger',
        disabled: false
      },
      content: ``,
      editorOption: {
        placeholder: '请输入文本...'
      },
      value: '1'
    }
  },
  mounted() {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    // 获取头部统计数量信息
    this.getUserCenterCount()
    // 获取订单信息
    this.orderInfo()
  },
  methods: {
    onEditorReady(editor) { // 准备编辑器
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    getUserCenterCount() {
      this.sapost('/dmc/account/userCenterCount', '', r => {
        let { retMsg, retCode } = r.data
        if (retCode === '0') {
          this.userCenterCount = r.data
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    orderInfo() {
      // 取出待支付的订单标识
      let id = this.$route.query.id
      let param = {id: id}
      this.sapost(`/dmc/order/${id}`, param, r => {
        if (r.data.result_code === 'SUCCESS') {
          this.code = r.data.code
          if (r.data.orderComment) {
            this.content = r.data.orderComment.content
            this.btntype.disabled = true
          }
        } else {
          if (r.data.result_msg === '用户未登录，请重新登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(r.data.result_msg)
        }
      })
    },
    msgpost () {
      if (!this.content) {
        this.$message.warning('请输入要评价的内容！')
        return
      }
      let params = {orderId: this.$route.query.id, content: this.content}
      this.sapost('/dmc/order/orderRate', params, r => {
        let { retMsg, retCode } = r.data
        if (retCode === '0') {
          this.$message.success(retMsg)
          this.btntype.disabled = true
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    defaultActive(value) {
      this.topMenuActive = value
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    },
    sex() {
      return this.user.sex
    },
    rank() {
      return this.user.rank
    }
  },
  watch: {
    sex(value) {
      if (value === 'm') {
        this.agent = '男'
      } else if (value === 'f') {
        this.agent = '女'
      } else {
        this.agent = '保密'
      }
    },
    rank(value) {
      switch (value) {
        case 'R2':
          this.userLevel = '铜牌'
          break
        case 'R3':
          this.userLevel = '银牌'
          break
        case 'R4':
          this.userLevel = '金牌'
          break
        case 'R5':
          this.userLevel = '钻石'
          break

        default:
          this.userLevel = '普通'
          break
      }
    }
  }
}
</script>

<style lang="less">
.newpopover[x-placement^="bottom"] {
  margin-top: 12px;
}
.newpopover[x-placement^="bottom"] .popper__arrow::after {
  top: 1px;
  margin-left: -6px;
  border-top-width: 0;
  border-bottom-color: rgb(25, 27, 46);
}
.newpopover[x-placement^="bottom"] .popper__arrow {
  top: -6px;
  left: 50%;
  margin-right: 3px;
  border-top-width: 0;
  border-bottom-color: rgb(25, 27, 46);
}
.newpopover {
  position: absolute;
  background: rgb(25, 27, 46);
  min-width: 130px;
  border-radius: 2px;
  padding: 0px;
  z-index: 2000;
  color: #ffffff;
  line-height: 1.4;
  text-align: justify;
  border: 0px;
  font-size: 14px;
  margin-left: 20px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  word-break: break-all;
}
.popdiv {
  cursor: pointer;
  width: 110px;
  height: 20px;
  padding: 10px;
}
.popdiv:hover {
  background-color: rgb(28, 203, 150);
  width: 110px;
  height: 20px;
  padding: 10px;
}
.popper__arrow {
  left: 85px !important;
}
.rightgo {
  margin-right: 10px;
}
.mtop{
    height: 120px;
    background-color: #122644;
    margin-bottom: 15px;
    position: relative;
    z-index: 99;
    .m-top-text{
      width: 1100px;
      margin: 0 auto;
      padding-left: 70px;
      .userInfo{
        color: #fff;
        display: inline;
        padding-left: 10px;
        img {
          float: left;
          margin-top: 35px;
          width: 100px;
          height: 100px;
          border-radius: 50px;
        }
        .text{
          float: left;
          margin-top: 38px;
          margin-left: 20px;
          line-height: 2em;
          .uname{
            font-size: 20px;
          }
        }
      }
      .main-nav {
        float: left;
        margin-top: 35px;
        font-size: 16px;
        margin-left: 60px;
        ul {
          li{
            height: 20px;
            line-height: 20px;
            float: left;
            padding: 0 15px;
            border-right: 2px solid #c3c7cd;
            span{
              display: block;
              margin-top:10px;
              text-align: center;
            }
            a{
              color: #c3c7cd;
            }
          }
          li:last-child {
            border-right:none
          }
          li.active,li:hover {
            a{
              color: #86b1bf;
            }
          }
        }
      }
      .userreset{
        float: right;
        margin-top: 35px;
        span{
          display: inline-block;
          color: #c3c7cd;
          padding: 5px 15px;
          border: 1px solid #c3c7cd;
          border-radius: 15px;
        }
      }
    }
  }

.feedcommit{
  width: 900px;
  margin: 0 auto;
  background-color: #fff;
  padding: 30px;
  p.title{
    background-color: #feeeee;
    border: 1px solid #fde3e2;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
    color: #f88c87;
    span{
      color: #ccc;
    }
  }
  .el-form{
    padding: 20px 0px;
    .el-form-item__label{
      text-align: left;
    }
    .el-input__inner{
      width: 260px;
    }
  }
  .edit{
    min-height: 300px;
    .ql-container{
      min-height: 300px;
      background-color: #fcfcfc;
    }
  }
  .btn{
    margin: 15px 0px;
    overflow: hidden;
    button{
      float: right;
      span{
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/feedcommit.vue